import { render } from "./FeatInfoEvent.vue?vue&type=template&id=341bc9e1&scoped=true"
import script from "./FeatInfoEvent.vue?vue&type=script&lang=js"
export * from "./FeatInfoEvent.vue?vue&type=script&lang=js"

import "./FeatInfoEvent.vue?vue&type=style&index=0&id=341bc9e1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-341bc9e1"

export default script